import { useState, useCallback, useMemo, type ReactNode } from 'react'
import type { ChatMessage } from '../../shared/types/chat'
import { DebugCtx } from './context'

export function DebugProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<{ conversationId: string | null; messages: ChatMessage[] }>({
    conversationId: null,
    messages: [],
  })

  const setDebugData = useCallback((conversationId: string | null, messages: ChatMessage[]) => {
    setData({ conversationId, messages })
  }, [])

  const value = useMemo(() => ({ data, setDebugData }), [data, setDebugData])

  return <DebugCtx.Provider value={value}>{children}</DebugCtx.Provider>
}
